import { AddInFeatureNotSupportedException } from 'common/exceptions/application/AddInFeatureNotSupportedException';
import CONFIG from 'config';

/**
 * Asserts that {@link CONFIG.isGraphApiEnabled} is `true`.
 *
 * @throws {@link AddInFeatureNotSupportedException} Thrown if `isGraphApiEnabled` is `false`
 */
export function assertHasGraphApi() {
  if (!CONFIG.isGraphApiEnabled) {
    throw new AddInFeatureNotSupportedException(
      'Microsoft Graph is not supported by this add-in'
    );
  }
}
